/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "5B5ECD1F-7FA9-426B-A738-099F26D3C749",
  "sitecoreApiHost": "https://scapim.dct.gov.ae/prod-vad/layout/web/v1",
  "jssAppName": "vaa",
  "defaultLanguage": "en",
  "sitecoreSiteName": "vaa_ae",
  "apiHost": "https://scapim.dct.gov.ae/prod-vad",
  "widgetUrl": "/where-to-go",
  "flightSearch": "http://flights.vadsc.in/{0}/flights/search/",
  "hotelSearch": "https://hotels.vadsc.in/?a_aid=44509&brandid=560850",
  "appInsightsInstrumentationKey": "3aa11bab-7f74-4f5f-b673-97b59fe3ce0a",
  "GEO_JSON_API": "https://scapim.dct.gov.ae/prod-vad/vaa/v1/explore-map/geojson",
  "SITECORE_API_KEY": "5B5ECD1F-7FA9-426B-A738-099F26D3C749",
  "LIVE_WEATHER_API": "https://scapim.dct.gov.ae/prod-vad/weather/v1/current",
  "EVENT_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1",
  "AUTO_COMPLETE_WEGO": "https://scapim.dct.gov.ae/prod-vad/wego",
  "AUTO_COMPLETE_TRAVEL_PAYOUT": "https://scapim.dct.gov.ae/prod-vad/travelpayouts/places2",
  "SOLR_FILTERS_DATA": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1",
  "SOLR_SEARCH_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1/global",
  "SOLR_FAVORITE_SEARCH_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1/favorite",
  "SMART_LIST_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1",
  "RFP_API": "https://scapim.dct.gov.ae/prod-vad/rfp/v1",
  "RFP_API_VIRUS_CHECK": "https://scapim.dct.gov.ae/prod-vad/storage/v1/scan",
  "COMPETITION_FORM_API": "https://scapim.dct.gov.ae/prod-vad/competition/v1/",
  "FORM_SUBMISSION_API": "https://scapim.dct.gov.ae/prod-vad/feedback/v1",
  "NEWSLETTER_SUBSCRIPTION_API": "https://scapim.dct.gov.ae/prod-vad/newsletter/v1/subscribe/vad",
  "SIMILAR_SEARCH_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1/similar",
  "TRIP_ADVISOR_API": "https://scapim.dct.gov.ae/prod-vad/trip-advisor/{location}?lang={language}",
  "GOOGLE_PLACES_API": "https://scapim.dct.gov.ae/prod-vad/operating-hours/v1/{placeId}",
  "TINT_API": "https://scapim.dct.gov.ae/prod-vad/tint/",
  "ADVANCE_SEARCH_API": "https://scapim.dct.gov.ae/prod-vad/vaa/search/v1/suggest?q={searchTerm}&lang={language}&limit={limit}",
  "PRELOAD_LINK_MEGAMENU_IMAGE": "true",
  "NO_RETINA_MEGANAV": "true",
  "ADD_TO_CALENDER_API": "https://scapim.dct.gov.ae/prod-vad/api/event/v1/{0}/add-to-calendar",
  "GOOGLE_ADD_TO_CALENDER_URL": "https://calendar.google.com/calendar/render?action=TEMPLATE&dates={startDate}/{endDate}&location={location}&text={title}&details={description}",
  "MAP_ACCESS_TOKEN": "undefined",
  "MAP_BOX_STYLE": "mapbox://styles/dctabudhabi/cl4faibzi002x14oc10prtrwl",
  "NEWSLETTER_SUBSCRIPTION_API_V2": "https://scapim.dct.gov.ae/prod-vad/api/v2/subscribe-newsletter",
  "FETCH_COUNTRIES_API": "https://scapim.dct.gov.ae/prod-vad/api/v1/countries"
};